import React from "react";
import close from "../../../assets/icons/close.svg";

export const ShowSchoolNames = ({ isOpen, onClose, selectedParticipants }) => {
    if (!isOpen || !selectedParticipants) return null;

    // Split multiple previous institutions if comma-separated
    const institutions = (selectedParticipants.previous_institutions || "").split(",");

    return (
        <div className="modal-overlay">
            <div
                className="modal-content"
                style={{
                    position: "relative",
                    width: "90%",
                    maxWidth: "600px",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    maxHeight: "70vh",
                    borderRadius: "8px",
                    background: "#fff",
                }}
            >
                {/* Header */}
                <div
                    className="modal-header"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "20px",
                        borderBottom: "1px solid #ddd",
                        position: "sticky",
                        top: 0,
                        background: "#fff",
                        zIndex: 10,
                    }}
                >
                    <h2 className="text-primary" style={{ margin: 0 }}>
                        School Names
                    </h2>
                    <button
                        style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                        }}
                        onClick={onClose}
                    >
                        <img src={close} alt="close" />
                    </button>
                </div>

                {/* Scrollable Content */}
                <div className="contestReport"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        padding: "20px",
                        overflowY: "auto",
                    }}
                >
                    {institutions.length > 0 ? (
                        institutions.map((inst, index) => (
                            <p
                                key={index}
                                style={{
                                    margin: 0,
                                    padding: "5px 10px",
                                    background: "#f5f5f5",
                                    borderRadius: "5px",
                                    fontSize: "14px",
                                    wordBreak: "break-word",
                                }}
                            >
                                {inst.trim()}
                            </p>
                        ))
                    ) : (
                        <p style={{ fontStyle: "italic", color: "#555" }}>No institutions available</p>
                    )}
                </div>
            </div>
        </div>
    );
};
